import PropTypes from 'prop-types';
import breakingPointsObj from 'styles/themes/wikifactory/styles/breakpoints';
import { customMedia } from 'styles/utils';

export default function Twix(props) {
  const { children, breakingPoint } = props;
  if (
    !(
      Array.isArray(children) &&
      children.length === 2 &&
      !children.includes(null)
    )
  )
    return null;
  let child = null;
  if (customMedia.greaterThan(breakingPoint)) {
    [child] = children;
  } else if (customMedia.lessThan(breakingPoint && children[1])) {
    [, child] = children;
  }
  return child;
}

Twix.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  breakingPoint: PropTypes.oneOf(Object.keys(breakingPointsObj)),
};

/*
  Twix is a media query breaking point switch
  Input 2 components tuple (mobile first) + optional breaking point
*/
